<template lang="pug">
  .spinner
</template>

<script>
// import { mapActions, mapState } from 'vuex'
import debug from 'debug'
let log = debug('component:Spinner')
export default {
  name: 'spinner',
  props: [],
  data () {
    return {
    }
  },
  beforeCreate: function () {
  },
  mounted: function () {
    log('Mounted')
  },
  computed: {
    // ...mapState('tasks', {
    //   tasksSorted: state => state.all.slice().sort((a, b) => a.title.localeCompare(b.title))
    // })
  },
  methods: {
    // ...mapActions('tasks', [
    //   'syncTask',
    // ])
  },
  components: {
  },
}
</script>

<style scoped lang="scss">
@import "../styles/_variables";
@import "../styles/_mixins";
.spinner {
  font-size: 5px;
  position: absolute;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(235, 55, 29, 0.2);
  border-right: 1.1em solid rgba(235, 55, 29, 0.2);
  border-bottom: 1.1em solid rgba(235, 55, 29, 0.2);
  border-left: 1.1em solid $brandPrimary;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
  border-radius: 50%;
  width: 100%;
  height: 100%;

  &:after {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }

  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
